<template>
  <div>
    <div class="h4">
      Список доступных методов
    </div>
    <ul class="list-unstyled">
      <li
        v-for="(route, index) in items"
        :key="index"
        class="my-2"
      >
        <api-doc-badge
          v-for="method in route.methods"
          :key="method"
          :method="method"
        />
        <i
          v-if="route.auth"
          class="el-icon-lock text-danger me-2"
        />
        <Link
          v-if="route.haveDoc"
          :href="`/api?method=${route.name}`"
        >
          {{ route.url }}
        </Link>
        <template v-else>
          {{ route.url }} [{{ route.name }}]
        </template>
      </li>
    </ul>
    <div class="h4 mt-5">
      Стандартные параметры
    </div>
    <div class="h5">
      Пагинация
    </div>
    <ul class="ml-4">
      <li><strong>page</strong> - запрашиваемая страница</li>
      <li><strong>perPage</strong> - кол-во элементов на странице</li>
    </ul>
    <p>В ответе данные о пагинации присутсвуют в поле:</p>
    <pre>
      pagination: {
          perPage: 15,
          currentPage: 1,
          lastPage: 1,
          countItems: 0,
      }
    </pre>
    <div class="h5">
      Сортировка
    </div>
    <ul class="ml-4">
      <li>
        <strong>sort</strong> - в формате "поле-поля"-"порядок сортировки",
        порядок сортировки: asc (по умолчанию) и desc
      </li>
    </ul>
    <p>Например:</p>
    <p><strong>?sort=id</strong></p>
    <p><strong>?sort=createdAt-desc</strong></p>
    <p><strong>?sort=price-asc</strong></p>

    <div class="h5 mt-5">
      Управление контентом (добавки)
    </div>
    <p>
      Для управления кол-вом выводимой информации
      (например при запросе списка курсов не нужно выводить контент и прочие данные)
    </p>
    <ul class="ml-4">
      <li>
        <strong>with</strong> - массив, значение или строка значений через запятую
      </li>
    </ul>
    <p class="mb-1">
      Стандартные значения:
    </p>
    <ul class="ml-4">
      <li>
        <strong>content</strong> - полное содержание (добавляет поле content)
      </li>
      <li>
        <strong>image</strong> - изображение (добавляет поле image)
      </li>
      <li>
        <strong>timestamps</strong> - временные метки (добавляет поля createdAt, updatedAt)
      </li>
      <li>
        <strong>full</strong> - выводит все доступные данные (для каждого метода свои)
      </li>
    </ul>
    <p class="mb-1">
      Например:
    </p>
    <p><strong>?with=content</strong></p>
    <p><strong>?with=content,image</strong></p>
    <p><strong>?with[]=timestamps&with[]=skills</strong></p>

    <div class="h5 mt-5">
      Фильтрация
    </div>
    <ul class="ml-4">
      <li>
        <strong>filter</strong> - дается массив данных для фильтрации вида ключ=>значение
      </li>
    </ul>
    <p>Если ключ заканчивается на:</p>
    <ul class="ml-4">
      <li>From (например priceFrom) применяется оператор &gt;=</li>
      <li>To (например priceTo) применяется оператор &lt;=</li>
      <li>Not (например oldPriceNot) применяется оператор &gt;&lt;</li>
      <li>Like (например titleLike) применяется оператор like %$value%</li>
    </ul>

    <p>Поля не выполняются если их нет в массиве разрешенных к фильтрации (задается на бакэнде)</p>

    <p>Если значение массив используется whereIn или whereNotIn</p>

    <p>
      Фильтр понимает отношения ManyToMany (например: categories=11)
      в отношениях можно использовать внешний ключ отличный от id, например: teachers.slug
      также работают все вышеперечисленные условия (From To и т.д.)
    </p>
    <p>Пример:</p>
    <pre>
     filter : {
       id: 100,
       article: [1212, 3233, 4333]
       priceFrom: 1000,
       priceTo: 9000,
       ratingFrom: 3,
       quantityNot: 0,
       'categories.slug': 'category-title',
       'skills.id': 3,
     }
    </pre>
  </div>
</template>

<script>

import { Link } from '@inertiajs/inertia-vue3';
import ApiDocLayout from '@/Layouts/ApiDocLayout';
import ApiDocBadge from '@/Pages/ApiDoc/ApiDocBadge';

export default {
  name: 'ApiDocIndex',
  components: { ApiDocBadge, Link },
  layout: ApiDocLayout,
  props: {
    items: {
      type: Array,
      required: true,
    },
  },
};
</script>
